import React, { useEffect, FC, useState } from 'react';
import ProjectForm from '../../components/ProjectForm/ProjectForm';

import { projectDetailsStore, projectDetailsData } from '../../stores/projectDetailsStore';
import { projectsData, projectsStore } from '../../stores/projectsStore';
import { cell_t } from '../../logic/types';
import { useParams, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import ProjectCell from '../../components/ProjectCell/ProjectCell';
import Link from '../../components/Link/Link';
import CreateButton from '../../components/CreateButton/CreateButton';
import { SpinnerSmall } from '@eyesee/eyesee-hub-npm-ui';
import { v4 as uuidv4 } from 'uuid';

import './project-details.scss';
interface ShowDropdown {
    [key: string]: boolean;
}

const ProjectDetails: FC = observer(() => {
    let { project_id }: { project_id: string } = useParams();
    const [showDropdown, setShowDropdown] = useState<ShowDropdown>({});

    let createNewCell = (cells: cell_t[]) => {
        const date = new Date();
        if (!cells) return;
        let newCell: cell_t = {
            end_date: new Date(date.setMonth(date.getMonth() + 1)).toISOString(),
            time: 1800,
            next_url: 'https://google.com',
            tasks: [],
            id: uuidv4(),
            randomize1: false,
            randomizeAll: false,
            version: 1,
            lang: 'en',
            name: 'New cell',
        };

        let cls = JSON.parse(JSON.stringify(cells));
        cls.push(newCell);
        projectDetailsStore.onUpdateCells(cls);
        projectDetailsStore.saveCell(newCell.id);
        projectsStore.fetchProjects();
    };

    const closeAllCSVPreviews = () => {
        setShowDropdown((prevValue: ShowDropdown) => {
            const newVal: any = {};
            for (let key in prevValue) {
                newVal[key] = false;
            }
            return newVal;
        });
    };

    const handleCSVDropdownClick = (e: React.MouseEvent<HTMLElement, MouseEvent>, cellId: string) => {
        e.preventDefault();
        e.stopPropagation();

        projectsStore.hideAll();

        const newShowDropdown: ShowDropdown = {};
        for (let key in showDropdown) {
            if (key === cellId) {
                newShowDropdown[key] = !showDropdown[key];
            } else {
                newShowDropdown[key] = false;
            }
        }

        setShowDropdown(newShowDropdown);
    };

    useEffect(() => {
        projectDetailsData.project_id = project_id;
        projectDetailsStore.getProject(project_id);
    }, []);

    useEffect(() => {
        const cellObj: any = {};
        projectDetailsData?.project?.cells?.forEach((cell) => {
            cellObj[cell.id] = false;
        });
        setShowDropdown(cellObj);
    }, [projectDetailsData?.project?.cells]);

    if (!projectDetailsData.project) return null;
    let project = projectDetailsData.project && projectDetailsData.project;

    return (
        <div
            className="project"
            onClick={() => {
                projectsStore.hideAll();
                closeAllCSVPreviews();
            }}
        >
            <div className="table-header">
                <h4>Project - {project.name}:</h4>
            </div>
            {projectDetailsData.state === 'loading' ? (
                <div className="project-spinner">
                    <SpinnerSmall />
                </div>
            ) : (
                <>
                    <ProjectForm data={projectDetailsData.project} linkPath={{ name: `/projects`, title: 'projects' }} />
                    <div className="cells">
                        <div className="cells__header">
                            <h5>Cells:</h5>
                            <CreateButton onSubmit={() => createNewCell(project.cells)} />
                        </div>
                        {projectDetailsData.project.cells.map((cell: cell_t, index) => (
                            <ProjectCell
                                previewLink={projectsStore.previewLink}
                                project={project}
                                cell={cell}
                                key={cell.id}
                                showDropdown={showDropdown}
                                handleCSVDropdownClick={handleCSVDropdownClick}
                                closeAllCSVPreviews={closeAllCSVPreviews}
                            />
                        ))}
                    </div>
                    {projectsData.link && <Link />}
                </>
            )}
        </div>
    );
});
export default ProjectDetails;
